module.exports = __webpack_public_path__ + "img/SN.f5514f58.png";